import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import api from "@/services/api";
import { toast } from "sonner";

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function GoogleCallback() {
  const navigate = useNavigate();
  const hasProcessed = useRef(false);
  const [error, setError] = useState("");

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;

    const hash = window.location.hash || "";
    const sessionId = new URLSearchParams(hash.replace(/^#/, "")).get("session_id");
    const proposito = sessionStorage.getItem("google_proposito") || "login";
    sessionStorage.removeItem("google_proposito");

    const run = async () => {
      try {
        const { data } = await api.post("/auth/google/sesion", { session_id: sessionId, proposito });
        window.history.replaceState(null, "", window.location.pathname);

        if (proposito === "registro") {
          if (data.ya_registrado) {
            toast.info("Ya tienes una cuenta con este correo. Inicia sesión.");
            navigate("/login");
            return;
          }
          if (data.solicitud_pendiente) {
            navigate("/registro-vendedor/espera");
            return;
          }
          sessionStorage.setItem("registro_method", "google");
          sessionStorage.setItem("registro_email", data.email);
          sessionStorage.setItem("registro_nombre", data.nombre || "");
          navigate("/registro-vendedor/tipo");
          return;
        }

        const { token, usuario, embajador } = data;
        localStorage.setItem("token", token);
        if (usuario?.perfil_comercial === "embajador_digital" && embajador) {
          localStorage.setItem("embajador", JSON.stringify(embajador));
          localStorage.setItem("userRole", "embajador");
        }
        let path = usuario.rol === "admin" || usuario.rol === "supervisor" ? "/admin" : "/vendedor";
        if (usuario.rol === "distribuidor") path = "/mayorista";
        if (usuario.perfil_comercial === "embajador_digital" && embajador) path = "/embajador/dashboard";
        window.location.href = path;
      } catch (e) {
        setError(e.response?.data?.detail || "No pudimos validar tu sesión de Google");
      }
    };
    run();
  }, [navigate]);

  return (
    <div className="min-h-screen flex items-center justify-center bg-gradient-to-br from-torta-cream to-torta-sand p-4">
      <div className="bg-white rounded-3xl shadow-xl p-8 max-w-md w-full text-center" data-testid="google-callback-card">
        {!error ? (
          <>
            <div className="w-10 h-10 border-4 border-torta-sand border-t-torta-brown rounded-full animate-spin mx-auto mb-4" />
            <p className="font-display text-xl text-torta-dark">Validando con Google...</p>
            <p className="text-sm text-torta-muted mt-1">Un momento por favor</p>
          </>
        ) : (
          <>
            <p className="font-display text-xl text-torta-dark mb-2">No pudimos continuar</p>
            <p className="text-sm text-torta-muted mb-5" data-testid="google-callback-error">{error}</p>
            <div className="flex gap-3 justify-center">
              <button onClick={() => navigate("/login")} className="px-5 py-2.5 rounded-xl bg-torta-brown text-white text-sm font-bold" data-testid="google-error-login-btn">Ir a iniciar sesión</button>
              <button onClick={() => navigate("/registro-vendedor")} className="px-5 py-2.5 rounded-xl border border-torta-sand text-torta-dark text-sm font-bold" data-testid="google-error-registro-btn">Registrarme</button>
            </div>
          </>
        )}
      </div>
    </div>
  );
}
